module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hres82e-room-detail box-tab",
    attrs: {
      "id": "hres82e-room-detail"
    }
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border collapsed"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(" \n          " + _vm._s(_vm.labels['HRES82EC4']['10']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES82EC4']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "radio col-xs-6"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.status),
      expression: "detail.status"
    }],
    attrs: {
      "type": "radio",
      "disabled": "disabled",
      "value": "A"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.status, "A")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail, "status", "A")
      }
    }
  }), _vm._v("\n                    " + _vm._s(_vm.labels['HRES82EC4']['120']) + " \n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio col-xs-6"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.status),
      expression: "detail.status"
    }],
    attrs: {
      "type": "radio",
      "disabled": "disabled",
      "value": "C"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.status, "C")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail, "status", "C")
      }
    }
  }), _vm._v("\n                    " + _vm._s(_vm.labels['HRES82EC4']['130']) + " \n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES82EC4']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "input",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.detail.roomno
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES82EC4']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "input",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.detail.desc_roomno
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES82EC4']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "input",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.detail.floor
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES82EC4']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "input",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.detail.building
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES82EC4']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "input",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.detail.qtypers + ' ' + _vm.labels['HRES82EC4']['70']
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES82EC4']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "input",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.detail.accessori
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES82EC4']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "input",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.detail.remark
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES82EC4']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "input",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.detail.codrespon + ' ' + _vm.detail.desc_codrespon
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 panel-left"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../assets/img/meetingroom.jpg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c818f9f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres82e/roomDetail.vue
// module id = 3699
// module chunks = 1